/**
 * A custom element that adds the current product/variant straight to the
 * cart and redirects to checkout, skipping the cart page entirely.
 */
class BuyNowButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.errorEl = this.querySelector('.buy-now-button__error');
    this.defaultText = this.button?.textContent || 'Buy it now';
    this.button?.addEventListener('click', this.handleClick);
    // Chrome/Safari restore this page from bfcache when the user hits "back"
    // from checkout, replaying the disabled/"Adding…" state frozen at
    // navigation time. Reset it whenever the page is shown this way.
    window.addEventListener('pageshow', this.handlePageShow);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick);
    window.removeEventListener('pageshow', this.handlePageShow);
  }

  handlePageShow = (event) => {
    if (!event.persisted || !this.button) return;
    this.button.disabled = false;
    this.button.textContent = this.defaultText;
    this.#setError('');
  };

  handleClick = async (event) => {
    event.preventDefault();
    if (!this.button || this.button.disabled) return;

    const form = this.closest('form');
    if (!form) return;
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    this.#setError('');
    this.button.disabled = true;
    this.button.textContent = 'Adding…';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.description || data.message || 'Could not add this item to your cart.');
      }

      window.location.assign('/checkout');
    } catch (error) {
      console.error('[buy-now-button]', error);
      this.button.disabled = false;
      this.button.textContent = this.defaultText;
      this.#setError(error.message || 'Something went wrong. Please try again.');
    }
  };

  #setError(message) {
    if (this.errorEl) this.errorEl.textContent = message;
  }
}

if (!customElements.get('buy-now-button')) {
  customElements.define('buy-now-button', BuyNowButton);
}
